import { useState } from "react";
import styled from "styled-components";

import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const ModalTitle = styled.h3`
    margin: 0 0 18px 0;
    padding: 0 0 12px 2px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 15px;
    font-weight: 700;
    color: #263b4b;
    text-align: left;
    width: 100%;
`;

const ModalNovoTipo = ({ tipo, onSaved }) => {
    const { closeModal } = useModal();
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();

    const isEdicao = Boolean(tipo?.id);

    const [nome, setNome] = useState((tipo?.nome ?? "").toUpperCase());
    const [ordem, setOrdem] = useState(
        tipo?.ordem != null ? String(tipo.ordem) : ""
    );
    const [salvando, setSalvando] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const nomeTrim = nome.trim();
        if (!nomeTrim) {
            notifyError("Informe o nome do tipo.");
            return;
        }

        try {
            setSalvando(true);

            const { data } = await api.post("/Painel/API/Prossmap/Tipos/Save/index.php", {
                id: tipo?.id ?? null,
                nome: nomeTrim,
                ordem: ordem === "" ? 0 : Number(ordem),
            });

            if (data?.success) {
                notifySuccess(
                    data?.message ||
                        (isEdicao ? "Tipo atualizado com sucesso." : "Tipo cadastrado com sucesso.")
                );
                if (onSaved) await onSaved();
                closeModal();
                return;
            }

            notifyError(data?.message || "Não foi possível salvar o tipo.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao salvar tipo.";
            notifyError(msg);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Overlay state>
            <Modal header close={closeModal} size="md">
                <ModalTitle>{isEdicao ? "EDITAR TIPO" : "NOVO TIPO"}</ModalTitle>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="NOME DO TIPO"
                        type="text"
                        valor={nome}
                        changeFunc={(e) => setNome(e.target.value.toUpperCase())}
                        placeholder="Ex.: EPI"
                        required
                    />
                    <FormComp
                        title="ORDEM"
                        type="numberOnly"
                        valor={ordem}
                        changeFunc={(e) => setOrdem(e.target.value)}
                        placeholder="Ex.: 1"
                    />
                    <FormComp
                        type="submit"
                        valor={salvando ? "SALVANDO…" : "SALVAR"}
                        disabled={salvando}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );
};

export default ModalNovoTipo;
